export enum ModuleTokens {
  Name = 'settings'
}
